import {
  NotificationTypeName,
  useUserProfileDetailCardQuery,
  useUserProfileDetailCardSaveNotificationSettingMutation
} from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export type INotificationSetting = {
  id: string;
  label: string;
  enabled: boolean;
};


export interface IData {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  preferredEmail: string;
  createdDate: string;
  settings: INotificationSetting[];
}

export function useQuery() {
  const tuple = useUserProfileDetailCardQuery({
    variables: {
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.loggedInUser?.person.id ?? '',
        firstName: tuple.data?.loggedInUser?.person.firstName ?? '',
        lastName: tuple.data?.loggedInUser?.person.lastName ?? '',
        phoneNumber: tuple.data?.loggedInUser?.person.phoneNumber ?? '',
        preferredEmail: tuple.data?.loggedInUser?.person.preferredEmail ?? '',
        settings: tuple.data?.loggedInUser?.person.notificationSettings
          .filter((node) => __removeWipNotifications(node)).map((node) => ({
            id: node.id ?? '',
            label: node.type.displayName ?? '',
            enabled: node.enabled ?? false
          })) ?? [],
        createdDate: tuple.data?.loggedInUser?.person.createdTimestamp.toFormat('DDDD') ?? DateTime.now().toFormat('DDDD')
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}

export function useSaveNotification() {
  const [
    fnMutate,
    tuple
  ] = useUserProfileDetailCardSaveNotificationSettingMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
function __removeWipNotifications(node: { __typename?: 'NotificationSetting'; id: string; enabled: boolean; type: { __typename?: 'NotificationType'; id: string; name: NotificationTypeName; displayName: string } }): boolean {
  if (node.type.name === 'dailyReportUpdate') {
    return false;
  } else if (node.type.name === 'planUpdate') {
    return false;

  } else if (node.type.name === 'taskCreated') {
    return false;
  } else if (node.type.name === 'planVersionUploaded') {
    return false;
  }
  return true;
}

